<template>
  <div
    v-if="showPaginator"
    class="d-flex justify-content-center align-items-center paginator-container"
  >
    <div class="d-flex text-center" :class="{ 'with-small-paginator': searchPaginator }">
      <div v-if="!searchPaginator" class="button-container" :class="{ prev: hasPrevPage }">
        <Button
          v-if="hasPrevPage"
          shape="outline-hover"
          :border-color="borderColor"
          :to="prevPageLink"
          :use-nuxt-link="useNuxtLink"
          :extra-data="{ 'aria-label': $t('common.paginator.sector.button') }"
          @click="prevPage($event)"
        >
          <div class="d-flex align-items-center">
            <Icon icon="bootstrap-chevron-left" class="mr-1" :width="14" :height="14" />
            <span class="d-none d-sm-inline">{{ $t('common.paginator.sector.button') }}</span>
          </div>
        </Button>
      </div>
      <div v-if="!searchPaginator" class="mt-2">
        <div class="d-flex align-items-center page-text">
          <label class="m-0 d-none d-sm-block">
            {{ $t('common.paginator.sector.text') }}
            <input
              type="number"
              :value="currentPage"
              class="input-page mx-2"
              @keyup.enter="changePage($event)"
            />
          </label>

          <p class="m-0">{{ $t('common.paginator.sector.text2') }} {{ totalPages }}</p>
        </div>
      </div>
      <div class="button-container" :class="{ next: hasNextPage }">
        <Button
          v-if="hasNextPage"
          width="full"
          :border-color="borderColor"
          :to="nextPageLink"
          :use-nuxt-link="useNuxtLink"
          :extra-data="{ 'aria-label': $t('common.paginator.sector.button2') }"
          @click="nextPage($event)"
        >
          <div class="d-flex align-items-center">
            <span class="d-sm-inline" :class="{ 'd-none': !searchPaginator }">{{
              $t('common.paginator.sector.button2')
            }}</span>
            <Icon icon="bootstrap-chevron-right" class="ml-1" :width="14" :height="14" />
          </div>
        </Button>
      </div>
    </div>
    <div v-if="searchPaginator" class="small-paginator-margin">
      <SmallPaginator
        v-bind="properties"
        @change-page="emitChangePage"
        @next-page="nextPage"
        @prev-page="prevPage"
      />
    </div>
  </div>
</template>

<script>
import Icon from 'UI/Icon';
import Button from 'UI/Button';
import { mapGetters } from 'vuex';
import SmallPaginator from '@/components/SearchResults/SmallPaginator';

export default {
  name: 'Paginator',
  components: {
    Button,
    Icon,
    SmallPaginator
  },
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    prevPageLink: {
      type: String,
      required: false,
      default: ''
    },
    nextPageLink: {
      type: String,
      required: false,
      default: ''
    },
    currentPage: {
      type: Number,
      required: true
    },
    useNuxtLink: {
      type: Boolean,
      default: true
    },
    searchPaginator: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPrevPage() {
      return this.currentPage > 1;
    },
    showPaginator() {
      return this.totalPages > 1;
    },
    borderColor() {
      return this.getExperience || 'default';
    },
    properties() {
      return {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        nextPageLink: this.nextPageLink,
        prevPageLink: this.prevPageLink,
        useNuxtLink: false
      };
    }
  },
  methods: {
    emitChangePage(page, e) {
      this.$emit('change-page', page, e);
    },
    changePage(e) {
      let page = e.target.value;
      page = parseInt(page);
      if (page > this.totalPages) page = this.totalPages;
      if (page < 1) page = 1;
      this.$emit('change-page', page, e);
    },
    nextPage(e) {
      this.$emit('next-page', e);
    },
    prevPage(e) {
      this.$emit('prev-page', e);
    }
  }
};
</script>
<style lang="scss" scoped>
.paginator-container {
  margin-top: 10px;

  .with-small-paginator,
  .small-paginator-margin {
    margin-left: auto;
    @include md {
      margin-right: auto;
    }
  }
  .with-small-paginator {
    position: relative;
    left: 90px;
    @include md {
      left: 0px;
      width: 100%;
    }
    .button-container {
      margin: 0 auto;
      @include md {
        width: 50%;
      }
      @include sm {
        width: 60%;
      }
    }
  }
  .small-paginator-margin {
    @include md {
      margin-top: 15px;
    }
  }

  @include md {
    flex-direction: column;
  }
}
.right {
  right: 0;
  @include md {
    position: initial !important;
    margin-top: 10px;
  }
}
.left {
  left: 15px;
  @include md {
    position: initial !important;
    margin-top: 10px;
  }
}
.button-container.prev {
  margin-right: 5px;
}
.button-container.next {
  margin-left: 5px;
}
.page-text {
  color: $strongGray;
  margin: 0 10px;
  .input-page {
    color: $strongGray;
    width: 28px;
    border-radius: 200%;
    border: 1px $strongGray solid;
    height: 28px;
    text-align: center;
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
